export enum ToastIntegrationsErrorBannerMessages {
  ERROR_MESSAGE_FETCHING_TOAST_DETAILS = 'There was an issue fetching your Toast Integration details. Please try again.',
  ERROR_MESSAGE_SYNC_MENUS = 'There was an issue updating Sync Menus Automatically. Please try again.',
  ERROR_MESSAGE_START_PAUSE_ORDERS = 'There was an issue sending/pausing your orders. Please try again.',
  ERROR_MESSAGE_CONFIG = 'There are errors saved in your Toast dashboard causing issues with the integration - you\'ll need to correct these issues on Toast.',
}
